<script>
    import { mapActions, mapState } from 'vuex';
    import HeaderSection from '~/components/header_section/components/header_section';
    import Loader from '~/components/loader/components/loader';
    import OrgSecurityQuestionSettingsForm from './ps_org_security_question_settings_form';
    import Panel from '~/components/panel/components/panel';
    import PasswordSettingsForm from './ps_org_password_settings_form';
    import MfaSettingsForm from './ps_mfa_settings_form';
    import VueButton from '~/components/button/components/button';
    import { MessageBox } from 'element-ui';

    export default {
        name: "password-settings-page",

        components: {
            HeaderSection,
            Loader,
            OrgSecurityQuestionSettingsForm,
            Panel,
            PasswordSettingsForm,
            MfaSettingsForm,
            VueButton
        },

        mounted() {
            this.getHeaderSectionHeight();
        },

        data() {
            return {
                headerSectionHeight: null,
            }
        },

        computed: {
            ...mapState('passwordSettings', [
                'hasPolicy',
                'hasSamlProvider',
                'loading',
                'settingsForm',
                'valid',
                'allowNativeLogin',
                'orgSecurityQuestionSettingsForm'
            ]),

            offsetHeight() {
                return `height: ${this.headerSectionHeight}px`;
            }
        },

        methods: {
            ...mapActions('passwordSettings', [
                'postPasswordSettingsForm',
                'postMfaSettings',
                'postPasswordSettingsForm',
                'postOrgSecurityQuestionSettingsForm',
                'getPasswordSettings'
            ]),

            saveSettings() {
                this.$refs.settingsForm.validateForm();
                if (this.valid) {
                    if (this.allowNativeLogin && this.settingsForm.block_direct_login) {
                        MessageBox.confirm('Disabling native login will also disable multi-factor authentication. Are you sure you want to proceed?', 'Warning', {
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            type: 'warning'
                        }).then(() => {
                            this.postPasswordSettingsForm()
                            .then(() => {
                                this.getPasswordSettings();
                            });
                        }).catch(() => {
                        });
                    } else {
                        this.postPasswordSettingsForm()
                        .then(() => {
                            this.getPasswordSettings();
                        });
                    }
                }
            },

            saveMfaSettings() {
                this.postMfaSettings();
            },

            saveSecurityQuestions() {
                this.postOrgSecurityQuestionSettingsForm();
                this.getPasswordSettings();
            },

            getHeaderSectionHeight() {
                const height = this.$refs.headerSection.$el;

                if (height) {
                    this.headerSectionHeight = height.clientHeight
                }
            },
        }
    }
</script>

<template>
    <div>
        <header-section
            ref="headerSection"
            title="Organization Password Settings"
            padding-value="20px 0">
        </header-section>

        <div class="header-section__spacer" :style="offsetHeight"></div>
        <div class="row">
            <div class="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                <panel title="User Password Requirements">
                    <template slot="headerRight">
                        <vue-button
                            type="primary"
                            :disabled="loading.formPost"
                            @click="saveSettings"
                            class="btn btn-sm btn-primary"
                        >
                            Save
                        </vue-button>
                    </template>

                    <template slot="body">
                        <loader :is-loading="loading.passwordSettings"></loader>
                        <password-settings-form ref="settingsForm"></password-settings-form>
                    </template>
                </panel>
            </div>

            <div v-if="allowNativeLogin" class="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                <panel title="Multi-Factor Authentication Settings">
                    <template slot="headerRight">
                        <vue-button
                            type="primary"
                            :disabled="loading.mfaSettings"
                            @click="saveMfaSettings"
                            class="btn btn-sm btn-primary"
                        >
                            Save
                        </vue-button>
                    </template>

                    <template slot="body">
                        <loader :is-loading="loading.mfaSettings"></loader>
                        <mfa-settings-form></mfa-settings-form>
                    </template>
                </panel>
            </div>

            <div class="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                <panel title="Security Questions Settings">
                    <template slot="headerRight">
                        <vue-button type="primary"
                                    :disabled="loading.orgSecurityQuestions"
                                    @click="saveSecurityQuestions"
                                    class="btn btn-sm btn-primary">
                            Save
                        </vue-button>
                    </template>

                    <template slot="body">
                        <loader :is-loading="loading.orgSecurityQuestions"></loader>
                        <org-security-question-settings-form
                            ref="securityQuestionSettingsForm"></org-security-question-settings-form>
                    </template>
                </panel>
            </div>
        </div>
    </div>
</template>